import React, { FC, Suspense } from 'react'
import { VStack } from '@chakra-ui/react'
import { Footer } from './Footer'
import { Header } from './Header'
import { LayoutSpinner } from './LayoutSpinner'
import { Content } from './Content'

export const Layout: FC<{
  children?: React.ReactNode,
  'data-testid'?: string
}> = ({ children }) => (
  <Suspense fallback={<LayoutSpinner />}>
    <VStack alignItems="stretch" h="full" overflow="auto" spacing={8} w="full">
      <Header />
      <Content>{children}</Content>
      <Footer />
    </VStack>
  </Suspense>
)
